exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "  .navbar-default {\r\n      \r\n/*    background-color: #FFFFFF;    \r\n   background-color:  #00284d;background-color:#444444*/\r\n\r\n \r\n}\r\n.project-heading\r\n{\r\n    font-size:20px !important;\r\n    font-weight: bold;\r\n   \r\n   \r\n}\r\n .navbar-fixed{\r\n     \r\n   background-color:lightgreen;\r\n\r\n \r\n}\r\n/*.navbar-header\r\n{\r\n    background-color:lightgreen;\r\n}*/\r\n\r\n.navbar-brand\r\n{\r\n    \t\r\n font-size:16px;\r\n\r\n}\r\nbody {\r\n    font-family: \"Lato\", sans-serif;\r\n/*    background-image:url('./img/back.png') !important;*/\r\n}\r\n\r\n\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/USer/Interviewfeedback/src/app/header/header.component.css
// module id = ../../../../../src/app/header/header.component.css
// module chunks = main